module.exports = __webpack_public_path__ + "static/media/galerija_2019 (34).82d0d382.jpg";